(function () {
  const removePoweredBy = () => {
    const target = Array.from(document.querySelectorAll("p")).find((p) =>
      p.innerText.includes("Powered by Globo") &&
      p.innerHTML.includes("form-builder-contact-form")
    );

    if (target) {
      const spacer = document.createElement("div");
      spacer.style.height = "20px";
      target.replaceWith(spacer);
    }
  };

  // Corre logo ao carregar
  removePoweredBy();

  // Corre sempre que há mudanças no DOM (ex: mudança de página)
  const observer = new MutationObserver(() => {
    removePoweredBy();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
